function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.778 4.222a6 6 0 010 8.485l-2.122 2.12-4.949 4.951a6 6 0 01-8.485-8.485l7.07-7.071a6.001 6.001 0 018.486 0zm-4.95 10.606L9.172 9.172l-3.536 3.535a4 4 0 005.657 5.657l3.535-3.536z"
});

var SvgKapselInKapsel = function SvgKapselInKapsel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8Zz4KICAgICAgICA8cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwSDI0VjI0SDB6Ii8+CiAgICAgICAgPHBhdGggZD0iTTE5Ljc3OCA0LjIyMmMyLjM0MyAyLjM0MyAyLjM0MyA2LjE0MiAwIDguNDg1bC0yLjEyMiAyLjEyLTQuOTQ5IDQuOTUxYy0yLjM0MyAyLjM0My02LjE0MiAyLjM0My04LjQ4NSAwLTIuMzQzLTIuMzQzLTIuMzQzLTYuMTQyIDAtOC40ODVsNy4wNy03LjA3MWMyLjM0NC0yLjM0MyA2LjE0My0yLjM0MyA4LjQ4NiAwem0tNC45NSAxMC42MDZMOS4xNzIgOS4xNzJsLTMuNTM2IDMuNTM1Yy0xLjU2MiAxLjU2Mi0xLjU2MiA0LjA5NSAwIDUuNjU3IDEuNTYyIDEuNTYyIDQuMDk1IDEuNTYyIDUuNjU3IDBsMy41MzUtMy41MzZ6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgKapselInKapsel as ReactComponent };